import { createApiRequest } from "../common";

/**
 * Tier C — reconnect a thread's link to a chosen live deal (single-row repoint).
 *
 * Server-only route (`POST /inbox/thread/reconnect`) — no Smithy *RequestContent
 * type exists (it's an inbox-recovery flag, not typed deal CRUD), so the shapes
 * are declared locally to mirror the api-server handler (handlers/inbox-thread.ts).
 * The handler RBAC-checks the target deal is in the caller's org reach, then
 * repoints the DealThreadLink through a Deal Manager op (relinkThreadUpdate).
 * Used when the user knows the right deal (a misrouted thread, or after they
 * reopened a deal elsewhere) and wants the thread attached to it.
 */
export interface ReconnectThreadRequest {
  externalThreadId: string;
  /** 'email' | 'imessage'. Defaults to 'email' server-side. */
  channel?: string;
  /** The live deal the thread should be repointed at. */
  newDealId: string;
}

export interface ReconnectThreadResponse {
  externalThreadId: string;
  channel: string;
  priorDealId: string;
  dealId: string;
  changed: boolean;
}

export const reconnectThreadApi = async (
  request: ReconnectThreadRequest,
): Promise<ReconnectThreadResponse> => {
  const apiRequest = createApiRequest<ReconnectThreadResponse>(
    "post",
    "/inbox/thread/reconnect",
  );
  return apiRequest(request);
};
